<template>
    <div class="container">
        <div class="filter_path">
            <el-form :inline="true" :model="params" class="form-inline">
                <el-form-item>
                    <el-input class="filter_input" v-model="params.keyword" placeholder="加工单号" size="mini"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input class="filter_input" v-model="params.keyword" placeholder="加工日期" size="mini"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.keyword" placeholder="状态" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.keyword" placeholder="加工类型" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.keyword" placeholder="加工厂" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-link type="danger" :underline="false">重置</el-link>
                    <el-button type="danger" size="mini">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="operate_row">
            <div class="">
                <el-button type="danger" size="customize" @click="dialogVisible = true">新建加工单</el-button>
                <el-button plain size="customize">费用项目</el-button>
                <el-button plain size="customize">删除</el-button>
            </div>
            <div class="status_table">
                <div class="" @click="changeStatus(1)">
                    原木加工单 wet
                </div>
                <div class="" @click="changeStatus(2)">
                    湿板(待烘干) <span>15</span>
                </div>
                <div class="" @click="changeStatus(3)">
                    干板(待检尺) <span>15</span>
                </div>
                <div class="">
                    待入库 <span>15</span>
                </div>
                <div class="">
                    已入库
                </div>
            </div>
        </div>
        <div class="table_path">
            <el-table :data="list" style="width: 100%" border height="100%" size="mini" header-cell-class-name="list_table_th">
                <el-table-column type="index"></el-table-column>
                <el-table-column type="selection"></el-table-column>
                <el-table-column label="操作"></el-table-column>
                <el-table-column label="加工日期"></el-table-column>
                <el-table-column label="加工单号"></el-table-column>
                <el-table-column label="状态"></el-table-column>
                <el-table-column label="批次号"></el-table-column>
                <el-table-column label="原木方数"></el-table-column>
                <el-table-column label="原木根数"></el-table-column>
                <el-table-column label="湿材方数"></el-table-column>
                <el-table-column label="干材方数"></el-table-column>
                <el-table-column label="加工厂"></el-table-column>
                <el-table-column label="加工费(合计)"></el-table-column>
                <el-table-column label="加工类型"></el-table-column>
                <el-table-column label="成材率"></el-table-column>
                <el-table-column label="制单人"></el-table-column>
            </el-table>
        </div>
        <div class="pagination_path">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <el-dialog v-dialog-drag :title="id == 0 ? '添加流水' : '修改'" :visible.sync="dialogVisible" width="440px" >
            <div class="dialog_form">
                <hr class="dialog_hr" />
                <el-form :model="create_form_params" :rules="rules" ref="create_form"  size="mini" label-width="110px" class="create_form" v-if="id == 0">
                    <el-form-item label="交易日期：" prop="params">
                        <el-input class="edit_input" v-model="create_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="我方账户名称：" prop="params">
                        <el-input class="edit_input" v-model="create_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="对方账户名称：" prop="params">
                        <el-input class="edit_input" v-model="create_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="交易类型：" prop="params">
                        <el-input class="edit_input" v-model="create_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="凭证：" prop="params">
                        <el-input class="edit_input" v-model="create_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="科目名称：" prop="params">
                        <el-input class="edit_input" v-model="create_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="交易金额(￥)：" prop="params">
                        <el-input class="edit_input" v-model="create_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="合同号：" prop="params">
                        <el-input class="edit_input" v-model="create_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：" prop="params">
                        <el-input class="edit_input" v-model="create_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                </el-form>
                <el-form :model="edit_form_params" :rules="rules" ref="edit_form"  size="mini" label-width="110px" class="edit_form" v-else>
                    <el-form-item label="账户名称：" prop="params">
                        <el-input class="edit_input" v-model="edit_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="卡号：" prop="params">
                        <el-input class="edit_input" v-model="edit_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="开户行：" prop="params">
                        <el-input class="edit_input" v-model="edit_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="户名：" prop="params">
                        <el-input class="edit_input" v-model="edit_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="初始金额：" prop="params">
                        <el-input class="edit_input" v-model="edit_form_params.params" placeholder=""></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer text-center">
                <el-button size="customize" plain @click="dialogVisible = false">取消</el-button>
                <el-button size="customize" type="danger" @click="dialogVisible = false">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .filter_path{
            padding: 15px; background-color: #F4F5F9;
            .form-inline{
                & > div{
                    margin-right: 30px;
                    button { margin-left: 25px; }
                }
            }
            .filter_input{
                width: 120px;
                & + .filter_input{ margin-left: 34px; }
            }
        }
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 28px 0 8px;
            .status_table{
                display: flex; align-items: center;
                & > div{
                    color: #222222; line-height: 20px; padding: 8px 15px; border:1px solid #ABABAB; cursor: pointer;
                    & > span{ color: #FF0000; margin-left: 3px; }
                    & + div{ margin-left: -1px; }
                }
            }
        }
        .table_path{ flex: 1; }
        .dialog_form{ height: 360px; text-align: center; }
        .create_form{
            display: inline-block;
            & > div{ margin-bottom: 11px; }
            .edit_input{ width: 177px; }
        }
        .edit_form{
            display: inline-block;
            & > div{ margin-bottom: 31px; }
            .edit_input{ width: 247px; }
        }

        .dialog-footer{
            padding-bottom: 48px; padding-top: 17px;
            .el-button--customize + .el-button--customize{ margin-left: 25px; }
        }
    }
</style>
<script>
    import pagination from '../../components/pagination.vue'
    export default {
        props: {
            status : {
                type: [String, Number],
                default : 1
            }
        },
        components:{
            pagination,
        },
        data(){
            return{
                params:{
                    keyword: "",
                    belong: "",
                    project: "",
                    per_page: 20
                },
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
                // dialog START
                dialogVisible : false,
                id : 0,
                create_form_params : {
                    params : "",
                },
                edit_form_params:{
                    params : "",
                },
                rules: {
                    company_name : [ { required: true, message: '请输入活动名称', trigger: 'blur' } ],
                },
                // dialog END
            }
        },
        methods:{
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            changeStatus(status){
                this.$emit("changeTab",status);
            }
        },
    }
</script>
